import { colors } from './colors';

export const retailColor = colors.green.dark;
export const retailOtherColor = colors.green.primary;

export const priorityNationalColor = colors.yellow.light;

export const priorityStateColors = [
  colors.green.dark,
  colors.green.light,
  colors.green.lighter,
  colors.green.lightest
];

export const retailNationalColors = [
  colors.yellow.lighter,
  colors.yellow.light,
  colors.yellow.primary,
  colors.orange.primary
];

export const retailStateColors = [
  colors.green.dark,
  colors.green.light,
  colors.green.lighter,
  colors.green.lightest
];

export const managerRolesColors = [
  colors.blue.dark,
  colors.blue.primary,
  colors.blue.light,
  colors.blue.lighter,
  colors.green.light
];
